/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import ReplyIcon from '@material-ui/icons/Reply';
import useProvider from '@src/hooks/useProvider';
import { SpecialMessageParser } from '@src/logic/specialmessageprocessing';
import { MessagingProvider } from '@src/model/frontendmodel';
import { addQuotedMessage } from '@src/reducers/chats';
import { activeChatIdSelector } from '@src/selectors/chats';
import { QuotedMessage, TimelineEvent } from '@src/types';
import dayjs from '@src/utils/dayjs';
import { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

type ChatMessageActionsProps = {
  chatId: string;
  message: TimelineEvent;
  disableActions: boolean;
  children: JSX.Element;
};

// Solo se van a mostar los mensajes citados luego de esta fecha
const minDateQuotedMsg =
  process.env?.REACT_APP_ACTIVATE_QUOTATION_FROM ?? '2023-02-01 00:00';

const ChatMessageActions: React.FC<ChatMessageActionsProps> = ({
  chatId,
  message,
  disableActions = false,
  children,
}) => {
  const dispatch = useDispatch();
  const provider = useProvider();
  const activeChatId = useSelector(activeChatIdSelector);

  const isMetaProvider = useMemo(
    () => provider === MessagingProvider.WHATSAPPB2CHAT,
    [provider]
  );

  const notDeliveredNotifyData = useMemo(
    () => SpecialMessageParser.isMsgNotDeliveredNotification(message?.text),
    [message]
  );

  const isIncomingMsg = useMemo(
    () => message?.direction === 'INCOMING' && !notDeliveredNotifyData,
    [message.direction, notDeliveredNotifyData]
  );

  const handleQuotedMsg = () => {
    dispatch(
      addQuotedMessage({
        chatId: activeChatId,
        quotedMessage: { chatId, ...message } as QuotedMessage,
      })
    );
    document.getElementById('composer-text-input')?.focus();
  };

  const isBlockedReply = useMemo(() => {
    if (message?.call?.id || message?.callPermissionResponse?.response)
      return true;
    if (message?.sendingTime && dayjs(minDateQuotedMsg).isValid()) {
      return dayjs(minDateQuotedMsg).diff(message.sendingTime, 'seconds') > 0;
    }
    return false;
  }, [message]);

  const [activeReply, setActiveReply] = useState(false);

  const hasReaction = useMemo(
    () => !!message?.emojiReaction?.filter(emoji => emoji !== null)?.length,
    [message]
  );

  return (
    <div
      onMouseOver={() => setActiveReply(true)}
      onMouseLeave={() => setTimeout(() => setActiveReply(false), 20)}
      className={'ActionContainer'.concat(isIncomingMsg ? ' is-incoming' : '')}
      style={{ marginBottom: hasReaction ? 28 : 5 }}
    >
      <div className="ActionItem">
        {children}
        {isMetaProvider && (
          <>
            {hasReaction && (
              <div className="EmojiMessage">{message.emojiReaction}</div>
            )}
            {activeReply && !isBlockedReply && !disableActions && (
              <div onClick={handleQuotedMsg} className="ReplyMessage">
                <ReplyIcon fontSize="inherit" />
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default ChatMessageActions;
